import React, { Fragment, Component } from 'react';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { renderField, renderTextArea, renderSelectField, renderCurrency, AsyncSelectField, SelectField } from '../../../Utils/renderField';
import { change } from 'redux-form';
import { api } from 'api';


class ItemArray extends Component {
    state = {
    }

    constructor(props) {
        super(props);
        // Crea una referencia para guardar el elemento textInput del DOM
        this.textInputDespacho = React.createRef();
        this.state = {
            optionsDespachoInterno: (search, index) => this.getDespachoInterna(search, index),
        }
    }

    componentDidUpdate(prevProps, prevState) {
    }

    getDespachoInterna = (search) => {
        const DESPACHO_VENTA_INTERNA = 80;

        let params = { entregado: true, estado: true, tipo_movimiento: DESPACHO_VENTA_INTERNA}
        if (search) params.search = search;

        // return api.get("ventainterna", params).
        return api.get("despachos/get_despachos_tipo", params).
            then((data) => {
                if (data) return data.results;
                return [];
            }).catch(() => {
                return [];
            });
    }

    setBodegas = (e, field) => {
        const { dispatch, form } = this.props;
        if (!e) {
            dispatch(change(form, `${field}.despacho_interno`, null));
            return;
        }
        dispatch(change(form, `${field}.despacho_interno`, e));
    };

    render() {
        const { index, field, elemento, item, eliminar } = this.props;

        return (
            <tr key={index} style={{ height: "68px" }}>
                <td className="text-center sin-borde-top" style={{ width: "48px" }}>
                    <img
                        className="action-img"
                        src={require('assets/img/icons/Cerrar.png')}
                        alt="Borrar"
                        title="Borrar"
                        onClick={() => {eliminar();}}
                    />
                </td>

                <td className="sin-borde-topzz">
                    <Field
                        ref={this.textInputDespacho}
                        id={`${field}.despacho_interno`}
                        key={`${field}.despacho_interno`}
                        name={`${field}.despacho_interno`}
                        valueKey="id"
                        labelKey="no_despacho"
                        label="Sucursal"
                        component={AsyncSelectField}
                        loadOptions={(search) => this.state.optionsDespachoInterno(search, index)}
                        top={{ top: "5px", position: "inherit" }}
                        isClearable={true}
                        className="form-control"
                        onChange={(e) => this.setBodegas(e, field)}
                    />
                </td>

                <td>
                    <Field
                        name={`${field}.despacho_interno.bodega_origen`}
                        valueKey="id"
                        labelKey="nombre"
                        label="bodega_origen"
                        component={renderSelectField}
                        options={field && elemento.despacho_interno && elemento.despacho_interno.bodega_origen ? [elemento.despacho_interno.bodega_origen] : []}
                        format={(value) => (value && typeof value === 'object' ? value.id : value)}
                        className="form-control"
                        top={{ top: "5px", position: "inherit" }}
                        disabled={true}
                    />
                </td>

                <td>
                    <Field
                        name={`${field}.despacho_interno.bodega_destino`}
                        valueKey="id"
                        labelKey="nombre"
                        label="bodega_origen"
                        component={renderSelectField}
                        options={field && elemento.despacho_interno && elemento.despacho_interno.bodega_destino ? [elemento.despacho_interno.bodega_destino] : []}
                        format={(value) => (value && typeof value === 'object' ? value.id : value)}
                        className="form-control"
                        top={{ top: "5px", position: "inherit" }}
                        disabled={true}
                    />
                </td>

            </tr>
        );
    }
}


const renderInterno = ({
    fields,
    meta: { error, submitFailed, form },
    dispatch,
    item, reRender, esEdicion,
    }) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="col-sm-12 form-group np-r mt-2 sin-borde p-0 color-header-tabla">
                <table className="table table-sm table-responsive-sm m-0 table-striped">
                    <thead>
                        <tr>
                            <th ></th>
                            <th>Despacho</th>
                            <th style={{ width: "30%" }}>Origen</th>
                            <th style={{ width: "30%" }}>Destino</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((field, index) => {
                            return (
                                <ItemArray
                                    dispatch={dispatch} // Para actualizar las bodegas
                                    form={form} // Para actualizar las bodegas

                                    key={index}
                                    index={index}
                                    field={field}
                                    item={item} // Instancia del tinerario
                                    elemento={fields ? fields.get(index) : null} // Elemento de los detalles
                                    esEdicion={esEdicion}
                                    eliminar={() => {
                                        fields.remove(index)
                                    }}
                                />
                            );

                        })}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-start mt-2">
                <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({})}>
                    AGREGAR DESPACHO
                </button>
            </div>
        </div>
        {submitFailed &&
            error &&
            <div className="invalid-feedback-array text-danger">
                {error}
            </div>}
    </div>
)

export default renderInterno;